import { useParams } from 'react-router-dom';
import useSWR from 'swr';
import { fetcher } from '../services/api';

export default function PartyProfile() {
  const { id } = useParams();
  const { data, isLoading } = useSWR(`parties/${id}/stats`, fetcher);

  if (isLoading) {
    return <div className="max-w-7xl mx-auto px-4 py-12">Cargando...</div>;
  }

  if (!data?.data) {
    return (
      <div className="max-w-7xl mx-auto px-4 py-12 text-center">
        <h1 className="text-2xl font-bold text-gray-900">Partido no encontrado</h1>
      </div>
    );
  }

  const { party, statistics } = data.data;

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      {/* Header */}
      <div className="card mb-8" style={{ backgroundColor: `${party.color_hex}10` }}>
        <div className="flex items-center space-x-4">
          <div
            className="w-20 h-20 rounded-full flex items-center justify-center text-white font-bold text-2xl"
            style={{ backgroundColor: party.color_hex }}
          >
            {party.abbreviation}
          </div>
          <div>
            <h1 className="text-3xl font-bold text-gray-900">{party.name}</h1>
            <p className="text-gray-600">{party.ideology || 'Partido político'}</p>
          </div>
        </div>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        <div className="card text-center">
          <p className="text-4xl font-bold text-gray-900">
            {statistics.politicians_by_level?.reduce((sum: any, l: any) => sum + l.count, 0) || 0}
          </p>
          <p className="text-gray-600">Representantes</p>
        </div>
        <div className="card text-center">
          <p className="text-4xl font-bold text-green-600">{statistics.avg_attendance}%</p>
          <p className="text-gray-600">Asistencia promedio</p>
        </div>
        <div className="card text-center">
          <p className="text-4xl font-bold text-blue-600">{statistics.initiatives?.total || 0}</p>
          <p className="text-gray-600">Iniciativas</p>
        </div>
      </div>

      {/* Top Politicians */}
      <div className="card">
        <h2 className="text-xl font-bold text-gray-900 mb-4">Representantes destacados</h2>
        <div className="space-y-4">
          {statistics.top_politicians?.map((p: any, i: number) => (
            <div key={p.id} className="flex items-center space-x-4 py-3 border-b border-gray-100 last:border-0">
              <span className="text-lg font-bold text-gray-400 w-6">{i + 1}</span>
              <img src={p.photo_url} alt={p.full_name} className="w-12 h-12 rounded-full bg-gray-200" />
              <div className="flex-1">
                <p className="font-medium text-gray-900">{p.full_name}</p>
                <p className="text-sm text-gray-500">{p.initiatives_count} iniciativas</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
